<template lang="">
	<div class="search-option-wrapper">
		<span>{{ label }}</span>
		<div class="search-option-wrapper__normal">
			<el-checkbox :value="value" @change="onchange" />
		</div>
	</div>
</template>

<script>
export default {
	props: ['label', 'name', 'value', 'onchange'],
	methods: {
		// printStatus: printStatus
	}
};
</script>
<style lang=""></style>
